import { Nav } from "./components/landing/sections/Nav";
import { Hero } from "./components/landing/sections/Hero";
import { ADay } from "./components/landing/sections/ADay";
import { Automations } from "./components/landing/sections/Automations";
import { WhatItDoes } from "./components/landing/sections/WhatItDoes";
import { Integrations } from "./components/landing/sections/Integrations";
import { HowItWorks } from "./components/landing/sections/HowItWorks";
import { Privacy } from "./components/landing/sections/Privacy";
import { Pricing } from "./components/landing/sections/Pricing";
import { FinalCTA } from "./components/landing/sections/FinalCTA";
import { Footer } from "./components/landing/sections/Footer";
import "./index.css";

export function App() {
  return (
    <>
      <Nav />
      <Hero />
      <ADay />
      <Automations />
      <WhatItDoes />
      <Integrations />
      <HowItWorks />
      <Privacy />
      <Pricing />
      <FinalCTA />
      <Footer />
    </>
  );
}

export default App;
